import { render } from "./ContentHtmlContainer.vue?vue&type=template&id=673b3b18"
import script from "./ContentHtmlContainer.vue?vue&type=script&lang=js"
export * from "./ContentHtmlContainer.vue?vue&type=script&lang=js"

import "./ContentHtmlContainer.vue?vue&type=style&index=0&id=673b3b18&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__